import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_BASE_URL } from "../config";

// Client-side SHA-256 password generator (guinness salt)
async function generateDeterministicKey(domain) {
    if (!domain.trim()) return '';
    const salt = 'guinness';
    const encoder = new TextEncoder();
    const firstBuf = await window.crypto.subtle.digest('SHA-256', encoder.encode(domain.trim()));
    const firstPass = Array.from(new Uint8Array(firstBuf)).map(b => b.toString(16).padStart(2, '0')).join('');
    const secondBuf = await window.crypto.subtle.digest('SHA-256', encoder.encode(firstPass + salt));
    const base64 = btoa(String.fromCharCode(...new Uint8Array(secondBuf)));
    const map = { '+': '_', '/': '@', '=': '-' };
    return base64.replace(/[+/=]/g, m => map[m]).substring(0, 23) + '!';
}

const MdpGenFTP = () => {

    // ── FTP section ──────────────────────────────────────────────
    const [host, setHost] = useState('');
    const [hosts, setHosts] = useState([]);
    const [usernameGenerated, setUsernameGenerated] = useState('');
    const [passGenerated, setPassGenerated] = useState('');

    useEffect(() => {
        axios
            .post(`${API_BASE_URL}/get_hosts`)
            .then((res) => {
                if (res.data.status === 'ok') setHosts(res.data.hosts);
            })
            .catch((err) => console.error('Failed to fetch hosts:', err));
    }, []);

    const generateFtpPassword = (selectedHost) => {
        if (!selectedHost) return;
        axios
            .post(`${API_BASE_URL}/generate_password`, { domain: selectedHost })
            .then((res) => {
                setUsernameGenerated(res.data.username);
                setPassGenerated(res.data.password);
            })
            .catch((err) => console.error(err));
    };

    // ── Generic domain generator ─────────────────────────────────
    const [domain, setDomain] = useState('');
    const [domainPass, setDomainPass] = useState('');
    const [copied, setCopied] = useState(false);

    useEffect(() => {
        if (!domain.trim()) { setDomainPass(''); return; }
        const timer = setTimeout(async () => {
            const pwd = await generateDeterministicKey(domain);
            setDomainPass(pwd);
        }, 200);
        return () => clearTimeout(timer);
    }, [domain]);

    const copyToClipboard = () => {
        navigator.clipboard.writeText(domainPass).then(() => {
            setCopied(true);
            setTimeout(() => setCopied(false), 1500);
        });
    };

    return (
        <div className="display-flex flex-direction-column gap-30">

            {/* ── FTP hebergement section ── */}
            <div>
                <h4 className="mb-10 color-third" >Identifiants FTP</h4>
                <label>Hébergement</label>
                <select
                    className="input"
                    style={{ minWidth: 110, padding: "10px 5px", fontFamily: "Montserrat" }}
                    onChange={(e) => {
                        const val = e.target.value;
                        setHost(val);
                        generateFtpPassword(val);
                    }}
                    value={host}
                >
                    <option value="">— Choisir un hébergement —</option>
                    {hosts.map((h) => (
                        <option key={h.prefix} value={h.prefix}>{h.name}</option>
                    ))}
                </select>

                <div className='mt-15'>
                    <label>Nom d'utilisateur</label>
                    <input type='text' value={usernameGenerated} readOnly className='input' />
                </div>

                <div className='mt-15'>
                    <label>Mot de passe</label>
                    <input type='text' value={passGenerated} readOnly className='input' />
                </div>
            </div>
        </div>
    );
};

export default MdpGenFTP;